import { io } from "socket.io-client";

//oakridge
// const SOCKET_URL = "wss://ws.myt-emr.com";

// consolacion
// const SOCKET_URL = "wss://ws.myt-conso.com";

// mactan
// const SOCKET_URL = "wss://ws.myt-mactan.com";

// mantlewood
const SOCKET_URL = "wss://ws-mantle.myt-emr.com";

// Localhost
// const SOCKET_URL = "wss://10.80.10.10:3000"; // Mantlewood
// const SOCKET_URL = "wss://10.80.7.226:3000"; // Oakridge 

const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  reconnectionAttempts: 10,
  timeout: 10000,
  withCredentials: false,
});

socket.on("message", () => {
  console.log(" Connected to WebSocket:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log(" Disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.error(" Connect error:", err.message);
});

socket.io.on("reconnect_attempt", (attempt) => {
  console.log(" Reconnect attempt #", attempt);
});

socket.io.on("reconnect_failed", () => {
  console.error(" Reconnect failed after max attempts");
});

export default socket;
